
import React from 'react';

export interface AssistantProps {
  id: number;
  name: string;
  image: string;
  rank: string;
}

export const AssistantCard: React.FC<AssistantProps> = ({ name, image, rank }) => {
  return (
    <div className="bg-white rounded-xl overflow-hidden shadow-md p-4 flex flex-col items-center">
      <div className="w-24 h-24 rounded-full overflow-hidden mb-4">
        <img 
          src={image} 
          alt={name} 
          className="w-full h-full object-cover"
        />
      </div>
      <div className="text-center">
        <h3 className="font-semibold text-lg">{name}</h3>
        <p className="text-sm text-gray-500">{rank}</p>
      </div>
    </div>
  );
};
